import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container, Typography } from '@material-ui/core';
import moment from 'moment';

// Styles
const useStyles = makeStyles((theme) => ({
  heroImage: {
    position: 'relative',
    display: 'block',
    zIndex: 100,
    height: '500px',
    '&:after': {
      position: 'absolute',
      content: '""',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '100%',
    },
  },
  imageTag: {
    display: 'inline-block',
    width: '100%',
    height: '100%',
    layout: 'fill',
    objectFit: 'cover',
  },
  backgroundBox: {
    width: '60%',
    top: '-150px',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.alternative.main,
    zIndex: 101,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  servicesText: {
    color: theme.palette.primary.main,
  },
  pressReleaseText: {
    fontWeight: 'Bold',
    color: theme.palette.gray.dark,
    fontSize: 16,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 12,
      fontWeight: 0,
    },
  },
  caption: {
    color: theme.palette.gray.dark,
    fontSize: 16,
    marginRight: 20,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 12,
    },
  },
  articleTitle: {
    color: theme.palette.primary.main,
  },
}));

const Hero = (props) => {
  const classes = useStyles();
  const { data } = props;
  return (
    <Box>
      <Box className={classes.heroImage}>
        <img
          src={data ? data.picture.url : '/'}
          className={classes.imageTag}
          alt="Hero"
        />
      </Box>
      <Container maxWidth="lg">
        <Box className={classes.backgroundBox}>
          <Box flexDirection="row" display="flex">
            <Typography variant="caption" className={classes.caption}>{moment(data ? data.publishedDate : '').format('YYYY-MM-DD - HH:mm')}</Typography>
            <Typography className={classes.pressReleaseText} variant="caption" color="secondary">{data ? data.tag : '-'}</Typography>
          </Box>
          <Box mt={1} />
          <Typography variant="h5" className={classes.articleTitle}>
            {' '}
            {data ? data.title : '-'}
          </Typography>
          <Box mt={1} />
          <Typography variant="body1">{data ? data.preamble : '-'}</Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
